import { render, staticRenderFns } from "./TableAlunosReposicao.vue?vue&type=template&id=3963ffd4&scoped=true"
import script from "./TableAlunosReposicao.vue?vue&type=script&lang=js"
export * from "./TableAlunosReposicao.vue?vue&type=script&lang=js"
import style0 from "./TableAlunosReposicao.vue?vue&type=style&index=0&id=3963ffd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3963ffd4",
  null
  
)

export default component.exports